export default function About() {
  return (
    <section id="about" className="relative bg-background-50 py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <div className="text-xs md:text-sm tracking-widest text-primary-500 font-semibold mb-4">
              ABOUT
            </div>
            <h2 className="font-heading font-black text-3xl md:text-5xl text-foreground-50 leading-tight tracking-tight">
              주식회사 프라임파트너스
            </h2>
            <div className="gold-divider w-16 my-8"></div>

            <p className="text-base md:text-lg text-foreground-200 leading-relaxed">
              풍부한 시장 경험과
              <br />
              체계적인 분석 시스템을 바탕으로
            </p>
            <p className="text-base md:text-lg text-foreground-200 leading-relaxed mt-5">
              투자자에게 보다 정확한 시장 정보와
              <br />
              효율적인 투자 전략을 제공하기 위해
              <br />
              최선을 다하고 있습니다.
            </p>

            <div className="gold-divider w-16 my-10"></div>

            <p className="text-sm md:text-base text-foreground-300 leading-relaxed mt-5 italic">
              투자는 결국 정보보다
              <br />
              판단력이 중요합니다.
            </p>
            <p className="text-sm md:text-base text-foreground-100 leading-relaxed font-semibold mt-3">
              주식회사 프라임파트너스는
              <br />
              <span className="text-gold-gradient">그 판단을 돕는 파트너가 되겠습니다.</span>
            </p>

            <div className="mt-10 grid grid-cols-2 gap-6">
              {[
                { label: "대표이사", value: "도관인" },
                { label: "사업자등록번호", value: "249-81-03770" },
                { label: "유사투자자문업", value: "정식 등록 법인" },
                { label: "설립연도", value: "2025년" },
              ].map((item) => (
                <div key={item.label} className="border-l-2 border-primary-500 pl-4">
                  <div className="text-xs text-foreground-400 tracking-wider">{item.label}</div>
                  <div className="text-base md:text-lg text-foreground-50 font-semibold mt-1">
                    {item.value}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 relative">
            <div className="relative overflow-hidden rounded-lg border border-background-300/60">
              <img
                src="https://static.readdy.ai/image/f943031b43fc8da94030f1522c0523e1/7b9455d725a69aef091c9be0442ce035.png"
                alt="프라임파트너스 전문 분석 환경"
                className="w-full aspect-[4/3] object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 via-transparent to-transparent"></div>
            </div>

            <div className="absolute -top-6 -left-6 md:-top-8 md:-left-8 border border-primary-500/60 bg-background-100/90 backdrop-blur px-6 py-5 rounded-lg">
              <div className="text-xs tracking-widest text-primary-500">회원 신뢰도</div>
              <div className="font-heading font-black text-3xl md:text-4xl text-foreground-50 mt-1">
                98.6<span className="text-primary-500">%</span>
              </div>
              <div className="text-xs text-foreground-300 mt-1">2025 회원 만족도</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}